/** @internal */
export const OP_PULLED = "Pulled" as const

/** @internal */
export type OP_PULLED = typeof OP_PULLED

/** @internal */
export const OP_NO_UPSTREAM = "NoUpstream" as const

/** @internal */
export type OP_NO_UPSTREAM = typeof OP_NO_UPSTREAM
